import { supabase } from './supabase';

// Interface for Twilio Phone Numbers
export interface TwilioPhoneNumbers {
  mainNumber: string;
  additionalNumbers: string[];
}

/**
 * Get Twilio phone numbers for a business
 */
export async function getTwilioPhoneNumbers(businessId: string): Promise<TwilioPhoneNumbers | null> {
  try {
    if (!supabase) {
      throw new Error('Supabase client is not initialized');
    }

    const { data, error } = await supabase
      .from('businesses')
      .select('VITE_TWILIO_PHONE_NUMBER, VITE_TWILIO_RESOURCE_PHONE_NUMBERS')
      .eq('id', businessId)
      .single();

    if (error) {
      console.error('Error fetching Twilio phone numbers:', error);
      return null;
    }

    return {
      mainNumber: data.VITE_TWILIO_PHONE_NUMBER || '',
      additionalNumbers: data.VITE_TWILIO_RESOURCE_PHONE_NUMBERS || []
    };
  } catch (error) {
    console.error('Error in getTwilioPhoneNumbers:', error);
    return null;
  }
} 